import React from "react";
import ComponentWidth from "../components/comWidth";

const About = () => {
    return (
        <>
            <ComponentWidth>
                <div id="onama">O nama</div>
            </ComponentWidth>
        </>
    );
};

export default About;
